import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { ContatoEmpresa } from '../../components'
import * as contatoConcessionariaActionCreators from '../../redux/modules/contatoConcessionaria'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class ContatoConcessionariaContainer extends Component {

  static propTypes = {
    concessionaria: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    multipleContatoConcessionaria: PropTypes.object.isRequired,
    fetchMultipleContatoConcessionaria: PropTypes.func.isRequired,
    destroyContatoConcessionaria: PropTypes.func.isRequired,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    const { concessionaria } = this.props
    await this.props.fetchMultipleContatoConcessionaria(concessionaria.id)
  }

  handleRedirectToNew = (concessionariaId) => {
    this.props.history.push(`/concessionarias/${concessionariaId}/contatos/new`)
  }

  handleEditResource = (concessionariaId, id) => {
    this.props.history.push(`/concessionarias/${concessionariaId}/contatos/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyContatoConcessionaria(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('contatoConcessionaria', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('contatoConcessionaria', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleContatoConcessionaria.toList().toJSON(),
      'contatoConcessionaria',
      [
        'id',
        'nome',
        'funcao.nome',
        'email',
        'telefone',
        'celular',
        'observacoes',
      ],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <ContatoEmpresa
        empresaTypePath='concessionarias'
        empresa={this.props.concessionaria}
        multipleContatoEmpresa={this.props.multipleContatoConcessionaria}
        onRedirectToNew={() => this.handleRedirectToNew(this.props.concessionaria.id)}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading}
      />
    )
  }
}

function mapStateToProps ({ contatoConcessionaria, status, sort, filter }, {concessionaria}) {
  const sortColumn = sort.getIn(['contatoConcessionaria', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['contatoConcessionaria', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['contatoConcessionaria', 'filterText']) || ''

  let map = filterMap(contatoConcessionaria, ['nome', 'funcao.nome', 'email', 'telefone', 'celular', 'observacoes'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleContatoConcessionaria: map.filter(t => t.get('concessionarias_ids').includes(concessionaria.id)),
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['contatoConcessionaria', 'error']),
    isLoading: status.getIn(['contatoConcessionaria', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...contatoConcessionariaActionCreators,
    ...flashMessageActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContatoConcessionariaContainer))
